// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"342":"87a99d7cfe4c3ff4","6187":"5ebd8128ddbaa919"}[chunkId] + ".css";
};